import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { EditIcon, DuplicateIcon, TrashIcon, CloneIcon } from '../../../../images/icons/WrapSvg';

class Popup extends React.Component {
    render() {
        const { open, intl, process, nochilds, info } = this.props;
        return (
            <Menu anchorEl={open} open={Boolean(open)} onClose={this.props.onClick('close')}>
                <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('edit')}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <EditIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: (process ? 'popup_edit_process_menuitem' : 'popup_edit_family_menuitem' ) })}
                    />
                </MenuItem>
                {process &&
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('open')}>
                        <ListItemIcon className={'icon c_bluish'}>
                            <EditIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_bluish' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_edit_form_menuitem' })}
                        />
                    </MenuItem>
                }
                {process && (
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('duplicity')}>
                        <ListItemIcon className={'icon c_bluish'}>
                            <DuplicateIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_bluish' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_duplicate_menuitem' })}
                        />
                    </MenuItem>
                )}
                {process &&
                    info &&
                    info.security &&
                    info.security.globalPermits &&
                    info.security.globalPermits.some((r) => r === '20') && (
                        <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('clone')}>
                            <ListItemIcon className={'icon c_bluish'}>
                                <CloneIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                classes={{ primary: 'barlow_semibold_label c_bluish' }}
                                inset
                                primary={intl.formatMessage({ id: 'popup_clone_menuitem' })}
                            />
                        </MenuItem>
                    )}
                {nochilds && (
                    <MenuItem className={'bg_ice_blue'} onClick={this.props.onClick('delete')}>
                        <ListItemIcon className={'icon c_lipstick'}>
                            <TrashIcon />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'barlow_semibold_label c_lipstick' }}
                            inset
                            primary={intl.formatMessage({ id: 'popup_delete_menuitem' })}
                        />
                    </MenuItem>
                )}
            </Menu>
        );
    }
}

Popup.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Popup = connect(
    mapStateToProps,
    null,
)(Popup);

Popup = injectIntl(Popup);

export default Popup;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Popup.js